/**
 * Non-secret per-device hint that someone has signed in here before. Signed-out
 * entry screens use it to choose between "Get started" (first launch) and
 * "Sign in" (returning). Survives sign-out on purpose; never used for auth.
 */
export const SIGNED_IN_BEFORE_KEY = "smartmanager_signed_in_before";

type Reader = Pick<Storage, "getItem">;
type Writer = Pick<Storage, "setItem">;

function browserStorage(): Storage | null {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
}

export function hasSignedInOnThisDevice(storage: Reader | null = browserStorage()): boolean {
  try {
    return storage?.getItem(SIGNED_IN_BEFORE_KEY) === "1";
  } catch {
    return false;
  }
}

export function markSignedInOnThisDevice(storage: Writer | null = browserStorage()): void {
  try {
    storage?.setItem(SIGNED_IN_BEFORE_KEY, "1");
  } catch {
    // Best-effort UI hint only.
  }
}
